var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashOffice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#5D6B72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "cash-office",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69998 5.88986H5.67498C4.35498 5.88986 3.25498 7.11208 3.25498 8.3343L2.64998 16.8899H21.35L20.8 8.3343C20.58 7.11208 19.48 5.88986 18.38 5.88986H10.9V4.66764H14.2V1.00098H5.39998V4.66764H8.69998V5.88986ZM23 18.112H1V23.0009H23V18.112ZM13.1 8.33431V10.7787H18.6V8.33431H13.1ZM5.39998 9.55653V8.33431H7.59998V9.55653H5.39998ZM8.70003 8.33431V9.55653H10.9V8.33431H8.70003ZM5.39998 12.0009V10.7787H7.59998V12.0009H5.39998ZM8.70003 10.7787V12.0009H10.9V10.7787H8.70003ZM5.39998 14.4454V13.2231H7.59998V14.4454H5.39998ZM8.70003 13.2231V14.4454H10.9V13.2231H8.70003ZM6.5 3.44538V2.22316H13.1V3.44538H6.5Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cash-office)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 24,
    height: 24
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashOffice);
export default __webpack_public_path__ + "static/media/cash-office.37063e41.svg";
export { ForwardRef as ReactComponent };